export default `
query ($sku:String!) {
  products(filter: {sku: {eq: $sku}}) {
    items {
      sku
      engraving_price
      engraving_enabled
      ... on CustomizableProductInterface {
          engraving_options {
              place {
                  label
                  type
              }
              anchors {
                  place
                  font
                  font_size
                  color
                  max_length
                  image {
                      url
                  }
                  position {
                      rotation
                      x
                      y
                  }
              }
          }
      }
    }
  }
}`;
